import { render } from "./ResourceActionHeader.vue?vue&type=template&id=e9b016f8"
import script from "./ResourceActionHeader.vue?vue&type=script&lang=js"
export * from "./ResourceActionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__